import Button, { ButtonProps } from '@mui/material/Button';
import { useFormContext } from '@/lib/form.ts';
import { useStore } from '@tanstack/react-form';
import { useShowLoadingDelayed } from '@/common/hooks/useShowLoadingDelayed.ts';

export const FormSubmit = ({ children, variant = 'contained', disabled, ...rest }: ButtonProps) => {
  const form = useFormContext();
  const isSubmitting = useStore(form.store, (state) => state.isSubmitting);
  const showLoading = useShowLoadingDelayed(isSubmitting);

  return (
    <Button
      {...rest}
      disabled={isSubmitting || disabled}
      variant={variant}
      loading={showLoading || rest.loading}
      loadingPosition={rest.loadingPosition ?? 'start'}
    >
      {children}
    </Button>
  );
};
